/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsfilterupcoming2Inputs */

const en_earningsfilterupcoming2 = /** @type {(inputs: Earningsfilterupcoming2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const de_earningsfilterupcoming2 = /** @type {(inputs: Earningsfilterupcoming2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende`)
};

/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Earningsfilterupcoming2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsfilterupcoming2 = /** @type {((inputs?: Earningsfilterupcoming2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsfilterupcoming2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsfilterupcoming2(inputs)
	return de_earningsfilterupcoming2(inputs)
});
export { earningsfilterupcoming2 as "earningsFilterUpcoming" }